import React from 'react'
import { Link } from "react-router-dom";
import { all_routes } from '../../router/all_routes';
import CollapseHeader from '../../../core/common/collapse-header';
import { checkPermission } from "../../../core/permissons/CheckPermissons"; 
const route = all_routes;

// Define navigation items with permissions
const navItems = [
  { label: "Administration", icon: "ti ti-settings-cog", link: route.location, permission: "ADMINISTRATION_ACCESS" },
  { label: "Vehicle Management", icon: "ti-car", link: route.companySettings, permission: "VEHICLE_MANAGER_ACCESS" },
  { label: "Key Management", icon: "ti-key", link: route.invoiceSettings, permission: "KEY_MANAGER_ACCESS" },
  { label: "Visitor Management", icon: "ti-user", link: route.floorplanCanvas, permission: "VISITOR_MANAGER_ACCESS" },
  { label: "Facility Management", icon: "ti-paint-roller", link: route.maintenanceTasksDashboard, permission: "FACULTY_MAINTENANCE_ACCESS" },
  { label: "Letter Management", icon: "ti-receipt", link: route.letter, permission: "LETTER_REGISTRATION_ACCESS" },
];

const Notifications = () => {
  return (
    <div>
    {/* Page Wrapper */}
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col-8">
                  <h4 className="page-title">Settings</h4>
                </div>
                <div className="col-4 text-end">
                  <div className="head-icons">
                    <CollapseHeader />
                  </div>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            {/* Settings Menu */}
              <div className="card">
                <div className="card-body pb-0 pt-2">
                  <ul className="nav nav-tabs nav-tabs-bottom">
                    {navItems.map((item, index) => (
                      item.permission && checkPermission(item.permission) && (
                        <li className="nav-item me-3" key={index}>
                          <Link
                            to={item.link}
                            className={`nav-link px-0 ${index === 0 ? "active" : ""}`} // First item as active by default
                          >
                            <i className={item.icon} /> {item.label}
                          </Link>
                        </li>
                      )
                    ))}
                  </ul>
                </div>
              </div>
            {/* /Settings Menu */}
            <div className="row">

  <div className="col-xl-9 col-lg-12">
    {/* Settings Info */}
    <div className="card">
      <div className="card-body">
        <h4 className="fw-semibold mb-3">Notification Settings</h4>
        <div className="settings-form">
          {/* General Notifications */}
          <div className="border-bottom mb-3 pb-3">
            <h5 className="fw-semibold mb-1">General Notifications</h5>
            <p>Select notifications</p>
          </div>
          <div className="border-bottom mb-3 pb-3">
            <div className="form-check d-flex align-items-center justify-content-between ps-0 mb-3">
              <label
                className="form-check-label text-gray-9 fw-medium"
                htmlFor="notification1"
              >
                Mobile Push Notifications
              </label>
              <input
                className="form-check-input"
                type="checkbox"
                defaultValue=""
                id="notification1"
                 defaultChecked
              />
            </div>
            <div className="form-check d-flex align-items-center justify-content-between ps-0 mb-3">
              <label
                className="form-check-label text-gray-9 fw-medium"
                htmlFor="notification2"
              >
                Desktop Notifications
              </label>
              <input
                className="form-check-input"
                type="checkbox"
                defaultValue=""
                id="notification2"
                 defaultChecked
              />
            </div>
            <div className="form-check d-flex align-items-center justify-content-between ps-0 mb-3">
              <label
                className="form-check-label text-gray-9 fw-medium"
                htmlFor="notification3"
              >
                Email Notifications
              </label>
              <input
                className="form-check-input"
                type="checkbox"
                id="notification3"
                 defaultChecked
              />
            </div>
            <div className="form-check d-flex align-items-center justify-content-between ps-0 mb-0">
              <label
                className="form-check-label text-gray-9 fw-medium"
                htmlFor="notification4"
              >
                SMS Notifications
              </label>
              <input
                className="form-check-input"
                type="checkbox"
                id="notification4"
                 defaultChecked
              />
            </div>
          </div>
          {/* /General Notifications */}
          {/* Custom Notifications */}
          <div className="border-bottom mb-3 pb-3">
            <h5 className="fw-semibold mb-1">Custom Notifications</h5>
            <p>
              Select when you will be notified when the following changes occur{" "}
            </p>
          </div>
          <div className="table-responsive notificaion-table">
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th />
                  <th>Push</th>
                  <th>SMS</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Legendary</td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Transaction</td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Email Verification</td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>OTP</td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Activity</td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Account</td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                         defaultChecked
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* /Custom Notifications */}
        </div>
      </div>
    </div>
    {/* /Settings Info */}
  </div>
</div>

          </div>
        </div>
      </div>
    </div>
    {/* /Page Wrapper */}
    {/* Delete Account */}
    <div className="modal custom-modal fade" id="delete_account" role="dialog">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0 m-0 justify-content-end">
            <button className="btn-close" data-bs-dismiss="modal" aria-label="Close">	
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <div className="success-message text-center">
              <div className="success-popup-icon">
                <i className="ti ti-trash-x" />
              </div>
              <h3>Delete Account</h3>
              <p className="del-info">Are you sure want to delete?</p>
              <div className="col-lg-12 text-center modal-btn">
                <Link to="#" className="btn btn-light" data-bs-dismiss="modal">Cancel</Link>
                <Link to={route.Users} className="btn btn-danger">Yes, Delete it</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* /Delete Account */}
    
  </div>
  );
};
export default Notifications;